export default __webpack_public_path__ + "static/media/09.f26ce3a2.jpg";